import React from "react";

const jobs = [
  {
    title: "Frontend Developer",
    location: "Pune / Remote",
    type: "Full Time",
    desc: "Build modern web apps using UI Library, REST APIs, and cloud services.",
    skills: ["Any UI Library", "JavaScript", "REST API", "Git", "HTML/CSS"],
    eligibility: "BCA / MCA / B.Sc / M.Sc/ B.E. / M.E. / Fresher / Experienced",
  },
  {
    title: "Backend Developer",
    location: "Pune / Remote",
    type: "Full Time",
    desc: "Design scalable backend systems and APIs. Node.js, Python, or Java experience required.",
    skills: ["Node.js", "Python", "Java", "SQL", "Cloud"],
    eligibility: "BCA / MCA / B.Sc / M.Sc/ B.E. / M.E. / Fresher / Experienced",
  },
  {
    title: "Internships (Software/Marketing)",
    location: "Pune / Remote",
    type: "Internship",
    desc: "Kickstart your career with hands-on experience in software development or digital marketing.",
    skills: ["Learning Attitude", "Communication", "Teamwork"],
    eligibility: "BCA / MCA / B.Sc / M.Sc/ B.E. / M.E. / Fresher",
  },
];

const Careers = () => (
  <div className="container py-5">
    <div className="text-center mb-5">
      <h1 className="fw-bold text-teal mb-3" style={{ letterSpacing: 1 }}>Careers at Vakralabs</h1>
      <p className="lead text-secondary">
        Join our passionate team and help us build creative digital solutions for India and beyond.<br />
        We value innovation, teamwork, and a growth mindset.
      </p>
    </div>
    <div className="row g-4 justify-content-center">
      {jobs.map((job, idx) => (
        <div className="col-12 col-md-6 col-lg-4 d-flex" key={idx}>
          <div className="card h-100 shadow-sm border-0 w-100">
            <div className="card-body d-flex flex-column justify-content-between">
              <div>
                <h5 className="card-title text-teal fw-bold text-center">{job.title}</h5>
                <div className="mb-2 text-center">
                  <span className="badge bg-info text-dark me-2">{job.location}</span>
                  <span className="badge bg-success">{job.type}</span>
                </div>
                <p className="card-text mb-2 text-center">{job.desc}</p>
                <div className="row mb-2 text-center">
                  <div className="col-12 col-md-6 mb-2 mb-md-0">
                    <strong>Skills:</strong>
                    <ul className="list-inline mt-1 mb-0">
                      {job.skills.map((skill, i) => (
                        <li className="list-inline-item badge bg-light text-dark border border-teal me-1 mb-1" key={i}>
                          {skill}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-12 col-md-6">
                    <strong>Eligibility:</strong><br />
                    <span
                      className="badge bg-warning text-dark mt-1"
                      style={{ whiteSpace: "pre-line", wordBreak: "break-word", display: "inline-block", maxWidth: "100%" }}
                    >
                      {job.eligibility}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
    <div className="text-center mt-5">
      <h5 className="text-secondary">
        Want to apply or interested? Send your resume to <a href="mailto:careers@vakralabs.com" className="fw-bold text-teal">careers@vakralabs.com</a>
      </h5>
    </div>
  </div>
);

export default Careers;